export const dateFallsWithin = (
  current: string,
  date1: string,
  date2: string
) => {
  const date = new Date(current.replace(" ", "T")); // convertir a fecha válida
  const start = new Date(date1 + "T00:00:00");
  const end =
    date2.split("-").length === 3 ? new Date(date2 + "T23:59:59") : false;

  return end ? date >= start && date <= end : current.slice(0, 10) === date1;
};
